const plansAccessCompanyMode = ['AN1HO', 'PROMO', 'OUTRO', 'COPY']
const plansAccessFreeMode = ['AN1HO', 'PROMO', 'OUTRO', 'COPY', 'MO1HO']

export function releaseCompanyMode(user) {
  return !!((user && user.plan && plansAccessCompanyMode.includes(user.plan.plan)) || user.role === 'admin')
}
export function releaseFreeMode(user) {
  return !!((user && user.plan && plansAccessFreeMode.includes(user.plan.plan)) || user.role === 'admin')
}
